// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LeftContent_wrapper_3gp9D","item":"LeftContent_item_3gE3-","collapse":"LeftContent_collapse_3495L","overseasVersion":"LeftContent_overseasVersion_HSpWu"};